import * as React from 'react';
import type { IconBaseProps, IconType } from 'react-icons';
import {
  MdCheck,
  MdCheckBox,
  MdCheckBoxOutlineBlank,
  MdChevronLeft,
  MdChevronRight,
  MdCurrencyYen,
  MdKeyboardArrowDown,
  MdMic,
  MdOutlinePerson,
  MdSearch,
} from 'react-icons/md';

/**
 * FDN UI Guideline のアイコン（Material Icons）。
 * ライブラリを実装詳細に閉じ込めるため、DS 内外とも本モジュール経由で import すること。
 *
 * - 装飾アイコンとして既定で aria-hidden を付与する（props で上書き可）
 * - Button 内でのサイズは tw:size-* クラスで制御される。react-icons の size prop は
 *   Button の CSS に上書きされるため使わないこと
 * - Button 内で端に固定する場合は data-icon="start" / "end" を付ける（button.tsx 参照）
 */
function createIcon(Icon: IconType) {
  function UiIcon(props: IconBaseProps) {
    return <Icon aria-hidden focusable="false" {...props} />;
  }
  UiIcon.displayName = `UiIcon(${Icon.name})`;
  return UiIcon;
}

export const CheckIcon = createIcon(MdCheck);
export const CheckboxBlankIcon = createIcon(MdCheckBoxOutlineBlank);
export const CheckboxMarkedIcon = createIcon(MdCheckBox);
export const ChevronLeftIcon = createIcon(MdChevronLeft);
export const ChevronRightIcon = createIcon(MdChevronRight);
export const ChevronDownIcon = createIcon(MdKeyboardArrowDown);
export const MicIcon = createIcon(MdMic);
export const SearchIcon = createIcon(MdSearch);
export const PersonIcon = createIcon(MdOutlinePerson);
export const YenIcon = createIcon(MdCurrencyYen);
